import { useMemo } from 'react';

export default function useImageUrl(filename) {
  return useMemo(() => {
    if (!filename) return null;
    return `${process.env.REACT_APP_STATIC_URL}/${filename}`;
  }, [filename]);
}
